"use client";

import { Check, Copy } from "lucide-react";
import { useState } from "react";

type TemplateTabsProps = {
	reactEmailCode: string;
	htmlCode: string;
};

export function TemplateTabs({ reactEmailCode, htmlCode }: TemplateTabsProps) {
	const [activeTab, setActiveTab] = useState<"react" | "html">("react");
	const [copied, setCopied] = useState(false);

	const code = activeTab === "react" ? reactEmailCode : htmlCode;

	async function copyToClipboard() {
		await navigator.clipboard.writeText(code);
		setCopied(true);
		setTimeout(() => setCopied(false), 2000);
	}

	return (
		<div>
			<div className="flex items-center gap-2 mb-4">
				<button
					type="button"
					onClick={() => setActiveTab("react")}
					className={`px-4 py-2 text-sm font-medium rounded-lg transition ${
						activeTab === "react"
							? "bg-gray-900 text-white"
							: "bg-gray-100 text-gray-600 hover:bg-gray-200"
					}`}
				>
					React Email
				</button>
				<button
					type="button"
					onClick={() => setActiveTab("html")}
					className={`px-4 py-2 text-sm font-medium rounded-lg transition ${
						activeTab === "html"
							? "bg-gray-900 text-white"
							: "bg-gray-100 text-gray-600 hover:bg-gray-200"
					}`}
				>
					HTML
				</button>
			</div>

			<div className="relative group">
				<button
					type="button"
					onClick={copyToClipboard}
					className="absolute top-3 right-3 p-2 rounded-lg bg-gray-800 hover:bg-gray-700 text-gray-400 hover:text-gray-200 transition z-10 flex items-center gap-2"
					aria-label="Copy code"
				>
					{copied ? (
						<>
							<Check className="w-4 h-4" />
							<span className="text-xs">Copied!</span>
						</>
					) : (
						<>
							<Copy className="w-4 h-4" />
							<span className="text-xs">Copy</span>
						</>
					)}
				</button>
				<pre className="bg-gray-900 rounded-lg p-4 overflow-x-auto max-h-[600px] overflow-y-auto">
					<code className="text-sm text-gray-100 font-mono whitespace-pre">
						{code}
					</code>
				</pre>
			</div>

			{activeTab === "react" && (
				<p className="text-sm text-gray-500 mt-3">
					Install:{" "}
					<code className="px-1.5 py-0.5 bg-gray-100 rounded text-gray-700">
						npm install @react-email/components
					</code>
				</p>
			)}
		</div>
	);
}
